import React from "react";

function Subtitle(){
    return(
    <div>
        <h1 className="subtitle">What I know</h1>
        <hr style={{width: "100px", backgroundColor: "#00989D", height: "3px", border: "none", marginBottom: "60px"}}></hr>
    </div>
    );
}

export default Subtitle;